module.exports = __webpack_public_path__ + "img/zuiminbanner_sample.4bc30adf.png";